import { render, staticRenderFns } from "./FS_twoTout.vue?vue&type=template&id=bde0f94e&"
import script from "./FS_twoTout.vue?vue&type=script&lang=js&"
export * from "./FS_twoTout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports